import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Edit from '../../Assets/Icons/Icon_Color_Edit.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_ChipGroup from '../ERUMAUI/UI_ChipGroup';
import { useAccounts } from '../../Contexts/Context_Accounts';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Input_Text_Long from '../ERUMAUI/UI_Input_Text_Long';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';

export default function Subwindow_Modal_Schedule_Edit({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Account_Fetch_ByID_Basic } = useAccounts();
    const [Account, Account_Set] = useState({ Name: "", Email: "" });
    const { Template_List } = useTemplating();
    const { Confirmer_Respond, Unsaved_Add, Unsaved_Clear } = useStatus();
    const Navigate = useNavigate();
    const Close = (Type) => {
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }

    const Confirm = async () => {
        const Cleared = await UI.Input_Evaluate([
            {
                ID: "Password_Current",
                Type: "Text",
                AC: "",
                Prompt: "This field is required"
            },
            {
                ID: "Password_New",
                Type: "Text",
                AC: "",
                Prompt: "This field is required."
            },
            {
                ID: "Password_New",
                Type: "Password_New",
                AC: "",
                Prompt: "This field is required."
            },
            {
                ID: "Password_New_Repeat",
                Type: "Text",
                AC: "",
                Prompt: "This field is required."
            },
            {
                ID_Start: "Password_Current",
                ID_End: "Password_New",
                Type: "Compare_Difference",
                AC: "",
                Prompt: "New password must not be the same as the old password."
            },
            {
                ID_Start: "Password_New",
                ID_End: "Password_New_Repeat",
                Type: "Compare_Sameness",
                AC: "",
                Prompt: "The new password and confirm new password doesn't match."
            }
        ]);
        if (Cleared) {
            Confirmer_Respond(true, {
                Old: UI.Element_Value_Get("Password_Current"),
                New: UI.Element_Value_Get("Password_New")
            }, true, "Window_User_Edit");
        }

    }

    const Cancel = async () => {
        Navigate("/user");
        Confirmer_Respond(false, {}, true, "Window_User_Edit");
    }


    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})} >
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    Edit your account details
                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}             >
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                {/* <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "10px", alignItems: "center" }}>
                    <div className='Subwindow_Content_Icon'>
                        <img src={Icon_Edit} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                    </div>
                    <div>
                        <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "left", marginBottom: "10px" }}>
                            Edit your account details
                        </h2>
                    </div>
                </div> */}
                <p className='General_Paragraph'>
                    <i>Successfully changing your password will sign you out of this session after.</i>
                </p>
                <UI_Divider />
                <UI_Form Composition="ByTwo">
                    <UI_Input_Text
                        id="Password_Current"
                        Label_Text="Current password"
                        Input_Type='password'
                        Required={true}
                        Input_Placeholder="Type your current password."
                    />
                    <UI_Divider />
                    <UI_Divider />
                    <UI_Input_Text
                        id="Password_New"
                        Label_Text="New password"
                        Input_Type='password'
                        Required={true}
                        Input_Placeholder="Type your new password."
                    />
                    <UI_Input_Text
                        id="Password_New_Repeat"
                        Label_Text="Confirm new password"
                        Input_Type='password'
                        Required={true}
                        Input_Placeholder="Type your new password again."
                    />
                </UI_Form>
                {/* <UI_Horizontal_Tabs
                    Selectors={[
                        {
                            Icon: <UI_Icon Name="User_Edit" />,
                            Text: "Change details",
                        },
                        {
                            Icon: <UI_Icon Name="User_Edit" />,
                            Text: "Change password",
                        }
                    ]}
                    UIDs={["Details", "Password"]}
                    Selected="Tab_Details"
                    Components={[
                        <UI_Form Composition="ByTwo">
                            <UI_Input_Text
                                Label_Text="First name"
                                Required={true}
                            />
                            <UI_Input_Text
                                Label_Text="Middle initial"

                            />
                            <UI_Input_Text
                                Label_Text="Last name"
                                Required={true}
                            />
                        </UI_Form>,
                        <>
                            <p className='General_Paragraph'>
                                <i>Successfully changing your password will sign you out of this session after.</i>
                            </p>
                            <UI_Divider />
                            <UI_Form Composition="ByTwo">
                                <UI_Input_Text
                                    id="Password_Current"
                                    Label_Text="Current password"
                                    Input_Type='password'
                                    Required={true}
                                    Input_Placeholder="Type your current password."
                                />
                                <UI_Divider/>
                                <UI_Divider/>
                                <UI_Input_Text
                                    id="Password_New"
                                    Label_Text="New password"
                                    Input_Type='password'
                                    Required={true}
                                    Input_Placeholder="Type your new password."
                                />
                                <UI_Input_Text
                                    id="Password_New_Repeat"
                                    Label_Text="Confirm new password"
                                    Input_Type='password'
                                    Required={true}
                                    Input_Placeholder="Type your new password again."
                                />
                            </UI_Form>
                        </>
                        
                    ]}
                /> */}

                <UI_Divider />

            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                <button className='General_Button Subwindow_Control' Type='Secondary' State="Positive" onClick={Confirm}>
                    Save changes
                </button>

            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
